<template>
  <div
    v-if="resolvedPerson"
    :class="{ 'mb-4 flex items-center gap-4': true }"
  >
    <div
      :class="{
        'flex items-center justify-center rounded-full border border-dashed border-www-color-neutral-medium-light bg-www-color-neutral-very-light': true,
      }"
    >
      <PtcPicture
        v-if="resolvedPerson.headshot?.asset"
        provider="sanity"
        :src="resolvedPerson.headshot?.asset?._ref"
        :img-attrs="{
          class: {
            'min-w-16 h-16 w-full rounded-full object-cover': true,
          },
        }"
        :modifiers="{
          crop: resolvedPerson.headshot?.crop,
          hotspot: resolvedPerson.headshot?.hotspot,
        }"
        :quality="75"
        :alt="resolvedImage?.altText || 'speaker headshot'"
      />
    </div>
    <div :class="{ 'flex flex-col gap-[2px]': true }">
      <span
        :class="{
          'text-[17px] font-bold leading-none text-www-color-neutral-dark': true,
        }"
      >
        {{ resolvedPerson.name }}
      </span>
      <span
        :class="{
          'text-sm font-semibold leading-none text-www-color-neutral-medium': true,
        }"
      >
        {{ resolvedPerson.jobTitle }}
      </span>
      <span
        :class="{
          'text-sm font-semibold leading-none text-www-color-neutral-medium': true,
        }"
      >
        {{ resolvedPerson.company }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import PtcPicture from '~/components/Atoms/PtcPicture/PtcPicture.vue';
import type { SpeakerSection } from '~/sanity/types';

const props = defineProps<{ speaker: NonNullable<SpeakerSection['speaker']>[number] }>();
const { getResolvedImage, getResolvedPerson } = useRefsStore();
const resolvedPerson = await getResolvedPerson(props.speaker?.reference?._ref);
const resolvedImage = await getResolvedImage(resolvedPerson.value?.headshot?.asset?._ref);
</script>
